module.exports = __webpack_public_path__ + "img/instrucciones.db0d3f58.svg";